import styled from 'styled-components';

export default comp => styled(comp)`
  .block-heading {
    h1 {
      @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        font-size: ${props => props.theme.type.largeMobile};
        line-height: ${props => props.theme.lineHeights.largeMobile};
        letter-spacing: ${props => props.theme.letterSpacing.large};
      }
      @media (min-width: ${props =>
          props.theme.breakpoints.tablet}) and (max-width: ${props =>
          props.theme.breakpoints.desktop}) {
        font-size: ${props => props.theme.type.large};
        line-height: ${props => props.theme.lineHeights.large};
        letter-spacing: ${props => props.theme.letterSpacing.large};
      }
    }
  }
`;
